<div class="login">
  <div class="login-div">
    <div id="logo">
      <img [src]="logo" (error)="onImageError()">
    </div>
    <app-login id="login-maske" (loginEvent)="onLogin($event)"></app-login>
  </div>
</div>
